module.exports = __webpack_public_path__ + "static/media/1POLICY34.50a9e81c.jpg";